import { helper } from '@ember/component/helper';
export default helper(function random([min, max]) {
  return Math.random() * (max - min) + min;
});


